<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { salesModels } from '$lib/stores/selection';

  /**
   * Whom the company mainly sells to, as its website shows it: businesses,
   * consumers, both, or the public sector. Several ticked mean any of them.
   * A company whose site gives no answer is not selected by any of them.
   *
   * Switched on by the customer or by a selection arriving, and off only by
   * the customer, which clears it — the contract every filter in this panel
   * keeps. The slugs are the server's (GET /filters/sales-models).
   */
  const models = ['b2b', 'b2b_and_b2c', 'b2c', 'b2g'];

  let enabled = false;
  $: if ($salesModels.length > 0) enabled = true;

  function toggleEnabled() {
    enabled = !enabled;
    if (!enabled) salesModels.set([]);
  }

  function toggle(model: string) {
    salesModels.set(
      $salesModels.includes(model)
        ? $salesModels.filter((m) => m !== model)
        : [...$salesModels, model]
    );
  }

  const checkbox =
    'h-3 w-3 rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200';
</script>

<div class={enabled ? 'm-2 rounded-control bg-surface-well p-3' : 'p-3'}>
  <label class="group flex cursor-pointer items-center">
    <input type="checkbox" checked={enabled} on:click={toggleEnabled} class="mr-2 {checkbox}" />
    <svg class="filter-mark mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
      />
    </svg>
    <span class="text-xs font-semibold text-gray-900 transition-colors group-hover:text-gray-700">
      {$_('filters.salesModel.title')}
    </span>
  </label>

  {#if enabled}
    <div class="mt-3 space-y-2">
      <p class="text-xs text-gray-400">{$_('filters.salesModel.anyOf')}</p>
      {#each models as model (model)}
        <label class="flex cursor-pointer items-start gap-2">
          <input
            type="checkbox"
            checked={$salesModels.includes(model)}
            on:change={() => toggle(model)}
            class="mt-0.5 {checkbox}"
          />
          <span class="text-sm text-gray-900">{$_(`filters.salesModel.${model}`)}</span>
        </label>
      {/each}
    </div>
  {/if}
</div>
